import { useDirectoryContext } from '@/features/drive/entities/directory/directory-context'
import { useMemo } from 'react'
import {
    INodeAction,
    IUseActionReturnType,
} from '@/features/drive/functionalities/actions/node/core/shared/utils/node-action-helpers'
import { Move } from 'lucide-react'
import { NodeMoveActionSubMenu } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-sub-menu'
import { useNodeItemContext } from '@/features/drive/entities/node/node-item-context'
import { INodeMoveActionAs } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-context'
import { useDirectorySelectionContext } from '@/features/drive/functionalities/selection/directory-selection-context'

export const NodeMoveAction = ({ as, styleType }: { as: INodeMoveActionAs; styleType?: 'light' | 'dark' }) => {
    const { nodePath } = useDirectoryContext()

    const {
        state: { selectedCount },
        methods: { clearSelection },
    } = useDirectorySelectionContext()

    const { node } = useNodeItemContext()

    return (
        <NodeMoveActionSubMenu
            name={node.name}
            path={nodePath || '/'}
            level={0}
            isEntrypoint
            onSuccess={clearSelection}
            mode={selectedCount > 0 ? 'selected' : 'node'}
            as={as}
            styleType={styleType}
        />
    )
}

export const useNodeMoveAction = (): IUseActionReturnType => {
    const {
        methods: { clearSelection },
    } = useDirectorySelectionContext()

    const action: INodeAction = useMemo(() => {
        return {
            icon: Move,
            label: '',
            call: clearSelection,
        }
    }, [clearSelection])

    return { action, nodes: <></> }
}
